import {ReactElement} from "react"
import {Button} from "antd"
import {t} from "@ui/common/intl"
import {TBoatInfo} from "@ui/api/user"
import PoolModal from "@ui/components/common/PoolModal"

type THintProps = {
  prop?: keyof TBoatInfo
  onClose: () => void
}
const HintModal = ({prop, onClose}: THintProps): ReactElement => {
  const hints: {[key in keyof TBoatInfo]: {text: ReactElement, icon?: ReactElement}} = {
    length: {
      text: <div>{t("profile.boat.length.hint.text")}</div>
    },
    width: {
      text: <div>{t("profile.boat.width.hint.text")}</div>
    },
    height: {
      text: <div>{t("profile.boat.height.hint.text")}</div>
    },
    draft: {
      text: <div>{t("profile.boat.draft.hint.text")}</div>
    },
    fuel_rate: {
      text: <div>
        <div>{t("profile.boat.fuel_rate.hint.text1")}</div>
        <div>{t("profile.boat.fuel_rate.hint.text2")}</div>
      </div>
    },
    cruising_speed: {
      text: <div>
        <div>{t("profile.boat.cruising_speed.hint.text1")}</div>
        <div>{t("profile.boat.cruising_speed.hint.text2")}</div>
      </div>
    },
    has_ais: {
      text: <div>{t("profile.boat.has_ais.hint.text")}</div>
    },
    mmsi: {
      text: <div>{t("profile.boat.mmsi.hint.text")}</div>
    }
  }

  return  (
    <PoolModal
      className="profile-hint-modal"
        open={!!prop}
        closable={false}
        width=""
        centered={true}
        footer={
          <div className="buttons">
            <Button className="button-primary" onClick={onClose}>
              {t("button.close")}
            </Button>
          </div>
        }
      >
        {prop && hints[prop] && (
          <div className="hint">
            {hints[prop]?.icon ?? ""}
            <div className="hint-text">{hints[prop]?.text}</div>
          </div>
        )}
      </PoolModal>
  )
}

export default HintModal
